/**
 * 预约看板
 */
import { APPOINTMENTBOARD } from '../types';

export default {
    name: `${APPOINTMENTBOARD}`,
    path: '/appointmentBoard',
    component: () => import(/* webpackChunkName: 'appointmentBoard' */ '@/views/appointmentBoard/'),
    redirect: { name: `${APPOINTMENTBOARD}Index` },
    meta: {
        title: '预约看板',
        savedPosition: { x: 0, y: 0 },
    },
    children: [
        {
            name: `${APPOINTMENTBOARD}Index`,
            path: 'index',
            component: () => import(/* webpackChunkName: 'appointmentBoard' */ '@/views/appointmentBoard/home/Home.vue'),
        },
        {
            name: `${APPOINTMENTBOARD}Schedule`,
            path: 'schedule',
            component: () => import(/* webpackChunkName: 'appointmentBoard' */ '@/views/appointmentBoard/schedule/Schedule.vue'),
        },
    ],
};
